/**
 * defa.views.UnitTestNoInstallerForm
 * Displays that you are not an installer
 * @version 1.2.0
 */
import Form     from 'scripts/poppet/form';
import template from 'templates/unitTestNoInstallerForm.jst.html';

const UnitTestNoInstallerForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template        : template,
	noInitValidation: true,
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default UnitTestNoInstallerForm;